import { IModel, Collection } from '../base/annotation';
import { Metamodel } from '../base/model';
import { shellStringResources } from '../../Resources/ShellStringResources';
import { RecurrenceScheduleOcccurence } from './recurrence-schedule-occurence';

export type RecurrenceDay = 'Sunday' | 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday';

@Metamodel.model({
    name: 'RecurrenceSchedule',
    display: [shellStringResources.ModelName_RecurrenceSchedule]
})
export class RecurrenceSchedule {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Minutes,
        constraint: {
            required: false
        }
    })
    public minutes: number[] = [];

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Hours,
        constraint: {
            required: false
        }
    })
    public hours: number[] = [];

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Weekdays,
        constraint: {
            required: false
        }
    })
    public weekDays: RecurrenceDay[] = [];

    @Metamodel.attribute({
        display: shellStringResources.ModelName_MonthDays,
        constraint: {
            required: false
        }
    })
    public monthDays: number[] = [];

    @Metamodel.attribute({
        type: RecurrenceScheduleOcccurence.MODEL,
        collection: Collection.Array,
        display: shellStringResources.ModelName_MonthlyOccurences,
        reference: true,
        constraint: {
            minOccurs: 0
        }
    })
    public monthlyOccurrences: RecurrenceScheduleOcccurence[] = [];
}
